import React, { createContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
// Stores methods
import * as storyMethods from '../constants/stories';
import * as constants from '../constants';
// Init state
import * as initState from './initialState';
// Store
const AppStore = createContext();

export const Provider = (props) => {
    const history = useHistory();
    // User state
    const [state, setState] = useState(initState.state);
    const [storyList, setStoryList] = useState([]);
    const [profile, setProfile] = useState(initState.profile);
    const [modals, setModals] = useState(initState.modals)

    // reducers
    const handleModals = (modal, value) => {
        setModals({
            ...modals,
            [modal]: value
        })
    }
    const acceptTerms = (value) => {
        if (value) {
            handleModals('terms', false)
        } else {
            history.goBack();
        }
    }
    // Auth
    const onAuthStateChanged = () => {
        const props = {
            setState, setProfile, handleModals
        }
        constants.onAuthStateChanged(props)
    };

    //Story methods
    const selectStory = (story) => {
        storyMethods.selectStory(story, state, setState, history)
    }
    const getStoryList = () => {
        storyMethods.getStoryList(setStoryList);
    }
    const followStory = (id) => {
        storyMethods.followStory(id, setState, state);
    }

    const reducers = {
        acceptTerms,
        // Story methods
        selectStory,
        getStoryList,
        followStory,
        // Modal methods
        handleModals,
        // User methods
        onAuthStateChanged
    };

    return (
        <AppStore.Provider
            value={{
                state,
                setState,
                setProfile,
                profile,
                modals,
                reducers,
                history,
                storyList
            }}>
            {props.children}
        </AppStore.Provider>
    )
};

export default AppStore;